/* RESPONSIBLE TEAM: team-proactive-support */
import Model, { attr } from '@ember-data/model';

export default class ProactiveSupportMessageFilters extends Model {
  @attr('string') declare filterHash: string;
}
